module.exports = __webpack_public_path__ + "img/web-P4-0-2.6c91fcff.svg";